import * as React from 'react'

import MutedIcon from '../icons/muted'
import UnmutedIcon from '../icons/unmuted'

import * as styles from './muteSwitcher.module.css'

interface IProps {
  muted?: boolean
  onMute?: () => void
  onUnmute?: () => void
}
const MuteSwitcher = ({
  muted,
  onMute = () => {},
  onUnmute = () => {}
}: IProps) => (
  <div className={styles.muteSwitchContainer}>
    {muted ? (
      <span className={styles.iconContainer} onClick={onUnmute} role="button">
        <MutedIcon width="14" height="14" />
        <span className={styles.iconLabel}>Unmute</span>
      </span>
    ) : (
      <span className={styles.iconContainer} onClick={onMute} role="button">
        <UnmutedIcon width="14" height="14" />
        <span className={styles.iconLabel}>Mute</span>
      </span>
    )}
  </div>
)

export default MuteSwitcher
